import gql from 'graphql-tag';

export default gql`
  query DropUser($email: String!) {
    DropUser(email: $email) {
      _id
      upc
      store
      price
      createdAt
      name
      address
      product {
        hotness
      }
    }
  }
`;
